import { render, staticRenderFns } from "./uploadLaudo.vue?vue&type=template&id=20f87272"
import script from "./uploadLaudo.vue?vue&type=script&lang=js"
export * from "./uploadLaudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports